<template>
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.key">
            {{ column.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="tableLoading === true">
          <td colspan="100%" class="text-center">
            <div>
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </td>
        </tr>

        <tr v-else-if="data.length === 0 && tableLoading === false">
          <td colspan="100%" class="text-center">
            <div class="">
              <div class="alert-icon">
                <i class="fa fa-info-circle"></i>
              </div>
              <span>No Records Found</span>
            </div>
          </td>
        </tr>

        <tr v-for="(row, rowIndex) in data" :key="rowIndex">
          <td
            v-for="column in columns"
            :key="column.key"
            :data-cell="column.label"
          >
            <slot :name="column.key" :row="row">
              {{ row[column.key] }}
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "DynamicTable",
  props: {
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    tableLoading: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
};
</script>

<style scoped>
table {
  background: #ffffff;
  width: 100%;
  overflow-x: auto;
}

th,
td {
  padding: 1rem;
}

th {
  background: #333f48;
  color: white;
}

tr:nth-of-type(2n) {
  background: #f1f1f1;
}

@media (max-width: 768px) {
  table {
    background: #ffffff;
    width: 100%;
    overflow-x: hidden;
  }
  th {
    display: none;
  }
  td {
    /* display: grid;
    grid-template-columns: 15ch auto; */
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 0.5rem 1rem;
  }
  td:first-child {
    padding-top: 2rem;
  }
  td:last-child {
    padding-bottom: 2rem;
  }
  td::before {
    content: attr(data-cell) ": ";
    font-weight: bold;
    text-transform: capitalize;
    color: #008000;
  }
}
</style>
